import React from 'react';
import { PropTypes } from 'prop-types';
import roundTo from 'round-to';
import { LIVECAPTIONS_USAGE } from '../../../zoom/ZoomConstants';
import { getFilterQueryParams } from '../../../../util/FetchTools';
import { LIVE_CAPTIONS_VIEW } from '../../../../constants/general';
import { totalToString } from '../../cdn/Usage/Usage';
import LiveCaptionsStackedBar from '../LiveCaptionsStackedBar';

const UPTIME_USAGE_CONFIG = {
   metric: LIVECAPTIONS_USAGE,
   title: 'Uptime Usage',
   csvFilename: 'LiveCaptions_UptimeUsage',
   tooltipText:
      '<div>This chart shows the total uptime hours of your</div>' +
      '<div>live captions sessions over the selected time period.</div>' +
      '<div>Uptime is measured from when the transcription</div>' +
      '<div>service starts until it ends.</div>',
   getUrl: (start, end, interval, { tags, streamNames }) => {
      const filterQuery = getFilterQueryParams([], tags, [], streamNames, LIVE_CAPTIONS_VIEW);
      return `/v2/captions/usage/timeseries?from=${start.format()}&to=${end.format()}&interval=${interval}${filterQuery}`;
   },
   series: [
      { key: 'whisper', label: 'Whisper', cssVar: '--info', zoomLabel: 'Whisper' },
      { key: 'deepgram', label: 'Deepgram', cssVar: '--danger', zoomLabel: 'Deepgram' },
   ],
   unitName: 'seconds',
   processingFn: (value) => roundTo(value / 3600, 3),
   formatTotal: (value, isLoadingOrError) => `${isLoadingOrError ? '0' : totalToString(value)} h`,
   guardOn204: false,
   labelWidthPx: 85,
   rightPanelMinWidthPx: 225,
   spinnerTopMarginPx: 65,
};

function UptimeUsageLiveCaptions({ height }) {
   return <LiveCaptionsStackedBar height={height} config={UPTIME_USAGE_CONFIG} />;
}

UptimeUsageLiveCaptions.propTypes = {
   height: PropTypes.number,
};

export default UptimeUsageLiveCaptions;
